// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1dzFs","header":"MessagesList_header__1Our0","chat":"MessagesList_chat__3Zx8M"};